import NotFound from "screens/public/not-found";
export default NotFound;
